import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const ContainerDiv = styled.div`
	background-color: ${color.secondary};
	width: 100%;
	height: 100%;
	padding: 14px 14px 14px 14px;
	border-radius: 0px 20px 0px 0px;

	margin-bottom: 20px;
`;

export const ContentDiv = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	align-items: center;
`;

export const Span = styled.span`
	font-size: 16px;
`;
